import Layout from '@/views/virtualTeachingAndResearchOffice/teachingMain.vue'

export default [
    {
        path: '/applyForOffice',
        name: '申请使用虚拟教研室',
        component: () => import(/* webpackChunkName: "applyForOffice" */ '@/views/virtualTeachingAndResearchOffice/Home/applyForOffice.vue')
    },
    {
        path: '/teachingResearchRoomSearch',
        name: '教研室搜索',
        component: () => import(/* webpackChunkName: "teachingResearchRoomSearch" */ '@/views/virtualTeachingAndResearchOffice/Home/search.vue')
    },
    {
        path: '/teachingResearchRoomNotificationMessage',
        name: '消息',
        component: () => import(/* webpackChunkName: "teachingResearchRoomNotificationMessage" */ '@/views/virtualTeachingAndResearchOffice/Home/notificationMessage.vue')
    },
    {
        path: '/TeachingResearchPortalHomepage',
        name: '教研室',
        component: () => import(/* TeachingResearchPortalHomepage */ '@/views/virtualTeachingAndResearchOffice/portalHomepage/index.vue')
    },
    {
        path: '/teachingMain/CourseHome',
        name: '样板课程',
        component: () => import(/* teachingMainCourseHome */ '@/views/virtualTeachingAndResearchOffice/courseHome/index.vue')
    },
    {
        path: '/teachingMain',
        name: '虚拟教研室',
        component: Layout,
        redirect: '/teachingMain/dynamicState',
        children: [
            {
                path: '/teachingMain/dynamicState',
                name: '教研室动态',
                component: () => import(/* webpackChunkName: "dynamicState" */ '@/views/virtualTeachingAndResearchOffice/dynamicState/index.vue')
            },
            {
                path: '/teachingMain/discussionActivities',
                name: '活动',
                component: () => import(/* webpackChunkName: "discussionActivities" */ '@/views/virtualTeachingAndResearchOffice/activity/index.vue')
            }, {
                path: '/teachingMain/resource',
                name: '资源库',
                component: () => import(/* webpackChunkName: "teachingMain/resource" */ '@/views/virtualTeachingAndResearchOffice/resource/index.vue'),
            },
            {
                path: '/teachingMain/samplePlateCourse',
                name: '样板课程共建',
                component: () => import(/* webpackChunkName: "samplePlateCourse" */ '@/views/virtualTeachingAndResearchOffice/sampleCurriculum/index.vue')
            },
        ]
    },
    {
        path: '/teachingMember',
        name: '教研室成员',
        component: () => import(/* webpackChunkName: "teachingMember" */ '@/views/virtualTeachingAndResearchOffice/member/index.vue')
    },
    {
        path: '/topicArticleDetailPage',
        name: '话题讨论详情',
        component: () => import(/* webpackChunkName: "topicArticleDetailPage" */ '@/views/virtualTeachingAndResearchOffice/activity/topicArticleDetailPage.vue')
    },
    {
        path: '/conferenceDetailPage',
        name: '会议直播详情',
        component: () => import(/* webpackChunkName: "conferenceDetailPage" */ '@/views/virtualTeachingAndResearchOffice/activity/conferenceDetailPage.vue')
    },
    {
        path: '/themeInfoDetailPage',
        name: '主题详情',
        component: () => import(/* webpackChunkName: "themeInfoDetailPage" */ '@/views/virtualTeachingAndResearchOffice/themeInfo/index.vue')
    },
    {
        path:'/document_view',
        name: '资源详情',
        component: () => import(/* webpackChunkName: "documentViewDetailPage" */ '@/views/virtualTeachingAndResearchOffice/documentView/index.vue')
    },
    {
        path:'/editTopic',
        name: '编辑话题讨论',
        component: () => import(/* webpackChunkName: "editTopic" */ '@/views/virtualTeachingAndResearchOffice/activity/components/editTopic.vue')
    },
    {
        path:'/editConference',
        name: '编辑会议直播',
        component: () => import(/* webpackChunkName: "editConference" */ '@/views/virtualTeachingAndResearchOffice/activity/components/editConference.vue')
    },
    {
        path:'/resource_homework_detail',
        name: '作业',
        component: () => import(/* webpackChunkName: "documentViewDetailPage" */ '@/views/virtualTeachingAndResearchOffice/resource/detail/pictureContext.vue')
    },
    {
        path:'/resource_topic_detail',
        name: '话题',
        component: () => import(/* webpackChunkName: "documentViewDetailPage" */ '@/views/virtualTeachingAndResearchOffice/resource/detail/pictureContext.vue')
    },
    {
        path:'/resource_testpaper_detail',
        name: '试卷',
        component: () => import(/* webpackChunkName: "documentViewDetailPage" */ '@/views/virtualTeachingAndResearchOffice/resource/detail/testpaperViewer.vue')
    },
]